import { Route, Routes } from "react-router-dom";
import WasteMapModule from ".";

const WasteMapRoute = () => {
  return (
    <Routes>
      <Route path="/*" element={<WasteMapModule />} />
    </Routes>
  );
};

export default WasteMapRoute;
